module.exports = __webpack_public_path__ + "img/coral-big.9189c6ac.png";